import React from "react";
import { InlineMath } from "react-katex";

export const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function gcd(a, b) {
  let x = Math.abs(a);
  let y = Math.abs(b);
  while (y) {
    const t = x % y;
    x = y;
    y = t;
  }
  return x || 1;
}

export function frac(num, den = 1) {
  if (den < 0) {
    num = -num;
    den = -den;
  }
  const g = gcd(num, den);
  return { num: num / g, den: den / g };
}

export function fracValue(f) {
  return f.num / f.den;
}

export function fracRaw(f) {
  if (f.den === 1) return String(f.num);
  return `${f.num}/${f.den}`;
}

export function fracLatex(f) {
  if (f.den === 1) return String(f.num);
  const sign = f.num < 0 ? "-" : "";
  return `${sign}\\frac{${Math.abs(f.num)}}{${f.den}}`;
}

export function signed(n) {
  return n < 0 ? `- ${Math.abs(n)}` : `+ ${n}`;
}

export function absLinearLatex(coef, constant = 0) {
  let inner = "";
  if (coef === 1) inner = "x";
  else if (coef === -1) inner = "-x";
  else inner = `${coef}x`;

  if (constant !== 0) inner += ` ${signed(constant)}`;
  return `\\left|${inner}\\right|`;
}

export function normalizeText(value) {
  return String(value ?? "")
    .toLowerCase()
    .replace(/−/g, "-")
    .replace(/–/g, "-")
    .replace(/,/g, ".")
    .replace(/\\left|\\right/g, "")
    .replace(/\\cdot/g, "*")
    .replace(/\s+/g, "");
}

export function userRaw(value) {
  if (typeof value === "string") return value;
  if (!value) return "";
  if (typeof value.raw === "string") return value.raw;
  if (typeof value.value === "string") return value.value;
  if (typeof value.text === "string") return value.text;
  return String(value ?? "");
}

function numberVariants(f) {
  const v = frac(f.num, f.den);
  const variants = new Set([fracRaw(v)]);
  variants.add(fracLatex(v).replace(/\\/g, ""));
  variants.add(String(fracValue(v)));
  variants.add(String(fracValue(v)).replace(".", ","));
  if (v.den === 1) variants.add(String(v.num));
  return [...variants].map(normalizeText);
}

export function containsNumber(raw, f) {
  const s = normalizeText(raw);
  return numberVariants(f).some((variant) => s.includes(variant));
}

export function containsAllNumbers(raw, nums) {
  return nums.every((n) => containsNumber(raw, n));
}

export function compareIntervalSets(parsed, expected) {
  if (!parsed || parsed.kind !== "intervals") return false;
  const got = parsed.intervals || [];
  if (got.length !== expected.length) return false;
  return got.every((g, i) => {
    const e = expected[i];
    const close = (a, b) =>
      (a === b) || (Number.isFinite(a) && Number.isFinite(b) && Math.abs(a - b) < 1e-8);
    return (
      close(g.left, e.left) &&
      close(g.right, e.right) &&
      !!g.leftClosed === !!e.leftClosed &&
      !!g.rightClosed === !!e.rightClosed
    );
  });
}

export function MathLine({ math }) {
  return (
    <div style={{ textAlign: "center", margin: "10px 0" }}>
      <InlineMath math={math} />
    </div>
  );
}

export function updatePart(answer, key, value) {
  return { ...(answer || {}), [key]: value };
}
